export default __webpack_public_path__ + "static/media/TH.5a746541.webp";